import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AutenticaService } from './../login/autentica.service';


@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private autentica: AutenticaService, private rota: Router){}

    canActivate(
        rota: ActivatedRouteSnapshot,
        estado: RouterStateSnapshot
    ) : Observable<boolean> | boolean {
        
        // ##############################################
        // VALIDA SE EXISTE DADOS DO MÉDICO E DO HOSPITAL
        // ##############################################
        if(sessionStorage.getItem("autenticacao") && sessionStorage.getItem("hospital")){
            // se tiver, autentica o usuário
            return this.autentica.usuarioEstaAutenticado();
        // SE NÃO TIVER, REMOVE POR REDUNDÂNCIA AS DUAS SESSÕES
        }else{
            sessionStorage.removeItem("autenticacao");
            sessionStorage.removeItem("hospital");
            // volta para a tela de login
            this.rota.navigate(['/login']);
            return false;
        }
        
    }

}


// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts